export enum UserTag {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
}

export interface IBasicPlanGroupMapping {
  range: [number, number]
  tag: UserTag
}
